import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useParams = pathTemplate => {
  const location = useLocation();
  const [params, setParams] = useState();

  const extractParamsFromUrl = () => {
    const paramNames = [];
    const pathRegex = pathTemplate.replace(/:([^/]+)/g, (_, key) => {
      paramNames.push(key); // Collect parameter names
      return '([^/]+)'; // Replace with a regex group
    });

    const regex = new RegExp(`^${pathRegex}$`);
    const match = location.pathname.match(regex);

    if (!match) {
      return null; // Return null if the URL doesn't match the path template
    }

    // Map the matched values to their corresponding parameter names
    return paramNames.reduce((params, paramName, index) => {
      params[paramName] = match[index + 1]; // match[0] is the full match
      return params;
    }, {});
  };

  useEffect(() => {
    if (location?.pathname) {
      setParams(extractParamsFromUrl());
    }
  }, [location?.pathname]);

  return params;
};

export default useParams;
